import auth from "@/auth.js";

export default {
  [auth.roles.USER]: [
    {
      title: "Sales",
      action: "folder",
      subItems: [
        { text: "Одиниці виміру", routeName: "salesUnits" },
        { text: "Контрагенти", routeName: "salesClients" },
        { text: "Товари та матеріали", routeName: "salesProducts" },
        { text: "Приход товару", routeName: "productReceipts" },
        { text: "Витрата товару", routeName: "productСonsumptions" },
      ],
    },
  ],
  [auth.roles.ADMINISTRATOR]: [
    {
      title: "Sales",
      action: "folder",
      subItems: [
        { text: "Одиниці виміру", routeName: "salesUnits" },
        { text: "Контрагенти", routeName: "salesClients" },
        { text: "Товари та матеріали", routeName: "salesProducts" },
        { text: "Приход товару", routeName: "productReceipts" },
        { text: "Витрата товару", routeName: "productСonsumptions" },
      ],
    },
  ],
  [auth.roles.SALES_MANAGER]: [],
  [auth.roles.ACCOUNT_MANAGER]: [],
  [auth.roles.ACCOUNT_CLIENT]: [],
};